import _objectWithoutProperties from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "ariaLabel", "review", "reviewLinkUrl", "reviewLinkHyperlinkType", "reviewLinkText", "reviewerImageUrl", "reviewerImageAlt", "reviewerImageTitle", "reviewerName", "reviewerTitle", "dataAnalyticsType", "dataAnalyticsValue", "srcSetSetting"];
var __jsx = React.createElement;
import React, { useContext } from 'react';
import styled from 'styled-components';
import styles from './ReviewCard.style';
import Para from '../../atoms/Para';
import RichText from '../../atoms/RichText/RichText';
import Anchor from '../../atoms/Anchor';
import Image from '../../atoms/Image';
import { linkTargetWindow } from '../../../constants/globalConstants';
import { Context } from '../../../global-state-context';
var ReviewCardBlock = styled.section.withConfig({
  componentId: "sc-b2f152-0"
})(["", ";"], styles);
var QuoteIcon = function QuoteIcon() {
  var _useContext = useContext(Context),
    predefinedTheme = _useContext.predefinedTheme;
  if (predefinedTheme === 'Full Width') {
    return __jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "29",
      height: "21",
      fill: "none"
    }, __jsx("path", {
      fill: "currentColor",
      d: "m4.055 20.666 3.89-6.722a2.784 2.784 0 0 1-.306.042c-.111.009-.213.013-.306.013-1.833 0-3.402-.652-4.708-1.958S.667 9.166.667 7.333c0-1.834.652-3.403 1.958-4.709C3.931 1.32 5.5.666 7.333.666c1.834 0 3.403.653 4.709 1.958C13.347 3.93 14 5.5 14 7.333c0 .602-.076 1.18-.23 1.734a6.455 6.455 0 0 1-.687 1.599l-5.75 10H4.055Zm15 0 3.89-6.722a2.785 2.785 0 0 1-.306.042c-.111.009-.213.013-.306.013-1.833 0-3.402-.652-4.708-1.958-1.305-1.306-1.958-2.875-1.958-4.708 0-1.834.653-3.403 1.958-4.709C18.931 1.32 20.5.666 22.333.666c1.834 0 3.403.653 4.709 1.958C28.347 3.93 29 5.5 29 7.333c0 .602-.076 1.18-.23 1.734a6.455 6.455 0 0 1-.687 1.599l-5.75 10h-3.278ZM7.327 10.388c.847 0 1.569-.296 2.166-.89a2.929 2.929 0 0 0 .896-2.159c0-.847-.297-1.569-.89-2.166a2.93 2.93 0 0 0-2.159-.896c-.847 0-1.569.297-2.166.89a2.93 2.93 0 0 0-.896 2.159c0 .847.296 1.569.89 2.166a2.93 2.93 0 0 0 2.159.896Zm15 0c.847 0 1.569-.296 2.166-.89a2.929 2.929 0 0 0 .896-2.159c0-.847-.297-1.569-.89-2.166a2.93 2.93 0 0 0-2.159-.896c-.847 0-1.569.297-2.166.89a2.929 2.929 0 0 0-.896 2.159c0 .847.296 1.569.89 2.166a2.93 2.93 0 0 0 2.159.896Z"
    }));
  }
  return __jsx("svg", {
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 32"
  }, __jsx("g", {
    transform: "translate(-9.001 -16.002)"
  }, __jsx("path", {
    d: "M19,27.7c-1.4,0-2.7,0.3-4,0.8c1.7-3.8,4.3-7.1,7.4-8.8c1-0.5,1.3-1.8,0.8-2.7 c-0.5-1-1.7-1.3-2.7-0.8c0,0,0,0,0,0C13.8,19.9,9,29,9,37.9c0.1,5.5,4.6,9.9,10.1,9.9c5.5-0.1,9.9-4.6,9.9-10.1 C28.9,32.1,24.5,27.7,19,27.7z"
  }), __jsx("path", {
    d: "M44,27.7c-1.4,0-2.7,0.3-4,0.8c1.7-3.8,4.3-7.1,7.4-8.8c1-0.5,1.3-1.8,0.8-2.7 c-0.5-1-1.7-1.3-2.7-0.8c0,0,0,0,0,0C38.8,19.9,34,29,34,37.9c0.1,5.5,4.6,9.9,10.1,9.9c5.5-0.1,9.9-4.6,9.9-10.1 C53.9,32.1,49.5,27.7,44,27.7z"
  })));
};
var ReviewCard = function ReviewCard(_ref) {
  var className = _ref.className,
    ariaLabel = _ref.ariaLabel,
    review = _ref.review,
    reviewLinkUrl = _ref.reviewLinkUrl,
    reviewLinkHyperlinkType = _ref.reviewLinkHyperlinkType,
    reviewLinkText = _ref.reviewLinkText,
    reviewerImageUrl = _ref.reviewerImageUrl,
    reviewerImageAlt = _ref.reviewerImageAlt,
    reviewerImageTitle = _ref.reviewerImageTitle,
    reviewerName = _ref.reviewerName,
    reviewerTitle = _ref.reviewerTitle,
    dataAnalyticsType = _ref.dataAnalyticsType,
    dataAnalyticsValue = _ref.dataAnalyticsValue,
    srcSetSetting = _ref.srcSetSetting,
    others = _objectWithoutProperties(_ref, _excluded);
  return __jsx(ReviewCardBlock, {
    className: "nva-review-card"
  }, __jsx(QuoteIcon, null), __jsx(RichText, {
    jsonContent: review,
    className: "nva-review-card__review-body heading_four"
  }), reviewLinkUrl && __jsx(Para, null, __jsx(Anchor, {
    className: "nva-review-card__anchor",
    title: reviewLinkText,
    to: reviewLinkUrl,
    hyperlinkType: reviewLinkHyperlinkType,
    "aria-label": ariaLabel,
    "data-analytics-type": dataAnalyticsType,
    "data-analytics-value": dataAnalyticsValue,
    ctaBehavior: linkTargetWindow.newWindow
  }, reviewLinkText)), __jsx("div", {
    className: "nva-review-card__reviewer reviewer-container"
  }, __jsx(Image, {
    className: "nva-review-card__reviewer-image",
    src: reviewerImageUrl,
    alt: reviewerImageAlt,
    title: reviewerImageTitle,
    srcSetSettingImg: srcSetSetting
  }), __jsx(Para, {
    className: "nva-review-card__reviewer-name heading_five"
  }, reviewerName), reviewerTitle && __jsx(Para, {
    className: "nva-review-card__reviewer-title u-caption"
  }, reviewerTitle)));
};
ReviewCard.defaultProps = {
  className: '',
  ariaLabel: '',
  review: '',
  reviewLinkUrl: '',
  reviewLinkHyperlinkType: '',
  reviewLinkText: '',
  reviewerImageUrl: '',
  reviewerName: ''
};
export default ReviewCard;